import { render, staticRenderFns } from "./PrinterStatusCard.vue?vue&type=template&id=f8557506&scoped=true&"
import script from "./PrinterStatusCard.vue?vue&type=script&lang=ts&"
export * from "./PrinterStatusCard.vue?vue&type=script&lang=ts&"
import style0 from "./PrinterStatusCard.vue?vue&type=style&index=0&id=f8557506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8557506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsItems})
